import React, { SetStateAction, useEffect, useState } from "react";

import { Box, Stack, TextField } from "@mui/material";
import { TableCell, TableRow } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import 'dayjs/locale/pt';

import { StyledTableHeadLeft } from "../../../Styles/tabelCellStyled/customTableCell";
import { CustomSelect, CustomTextField } from "../../../Styles/theme/customThemeprovider";
import BasicPopover from "../../../Components/Popover";
import { IPage6 } from "../../../Interfaces/cadernos/caderno6";
import updateLocale from 'dayjs/plugin/updateLocale';
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { meses_ano } from "../../../Func_genericas/valores_estaticos";

dayjs.locale('pt');

dayjs.extend(updateLocale);

// Replace "en" with the name of the locale you want to update.
dayjs.updateLocale('pt', {
  // Sunday = 0, Monday = 1.
  weekStart: 0,
});
export interface ITableRegaProps {
  tabela: IPage6 | undefined;
  setTabela: React.Dispatch<SetStateAction<IPage6 | undefined>>;
  set_date_camp_1_default: React.Dispatch<SetStateAction<string | undefined>>;
  set_date_camp_2_default: React.Dispatch<SetStateAction<string | undefined>>;
  set_date_camp_3_default: React.Dispatch<SetStateAction<string | undefined>>;
  set_date_camp_4_default: React.Dispatch<SetStateAction<string | undefined>>;
  set_date_camp_5_default: React.Dispatch<SetStateAction<string | undefined>>;
  set_date_camp_6_default: React.Dispatch<SetStateAction<string | undefined>>;
  set_date_camp_7_default: React.Dispatch<SetStateAction<string | undefined>>;
  numero_semana_default: number | undefined;
  mes_default: string | undefined;
  date_camp_1_default: string | undefined;
  date_camp_2_default: string | undefined;
  date_camp_3_default: string | undefined;
  date_camp_4_default: string | undefined;
  date_camp_5_default: string | undefined;
  date_camp_6_default: string | undefined;
  date_camp_7_default: string | undefined;
  set_flag_editado: React.Dispatch<SetStateAction<boolean>>;

}

export const TabelaCalendarioRega: React.FC<ITableRegaProps> = ({
  tabela,
  setTabela,
  numero_semana_default,
  mes_default,
  date_camp_1_default,
  date_camp_2_default,
  date_camp_3_default,
  date_camp_4_default,
  date_camp_5_default,
  date_camp_6_default,
  date_camp_7_default,
  set_date_camp_1_default,
  set_date_camp_2_default,
  set_date_camp_3_default,
  set_date_camp_4_default,
  set_date_camp_5_default,
  set_date_camp_6_default,
  set_date_camp_7_default,
  set_flag_editado,
}) => {

  const [error_capacidade_utili, set_capacidade_utili] = useState<boolean>(false);
  const [error_reserva_facilmente_utiliz, set_reserva_facilmente_utiliz] = useState<boolean>(false);
  const [error_prefundidad_radi_camp_1, set_prefundidad_radi_camp_1] = useState<boolean>(false);
  const [error_prefundidad_radi_camp_2, set_prefundidad_radi_camp_2] = useState<boolean>(false);
  const [error_prefundidad_radi_camp_3, set_prefundidad_radi_camp_3] = useState<boolean>(false);
  const [error_prefundidad_radi_camp_4, set_prefundidad_radi_camp_4] = useState<boolean>(false);
  const [error_prefundidad_radi_camp_5, set_prefundidad_radi_camp_5] = useState<boolean>(false);
  const [error_prefundidad_radi_camp_6, set_prefundidad_radi_camp_6] = useState<boolean>(false);
  const [error_prefundidad_radi_camp_7, set_prefundidad_radi_camp_7] = useState<boolean>(false);
  const [error_capacidade_campo_camp_1, set_capacidade_campo_camp_1] = useState<boolean>(false);
  const [error_capacidade_campo_camp_2, set_capacidade_campo_camp_2] = useState<boolean>(false);
  const [error_capacidade_campo_camp_3, set_capacidade_campo_camp_3] = useState<boolean>(false);
  const [error_capacidade_campo_camp_4, set_capacidade_campo_camp_4] = useState<boolean>(false);
  const [error_capacidade_campo_camp_5, set_capacidade_campo_camp_5] = useState<boolean>(false);
  const [error_capacidade_campo_camp_6, set_capacidade_campo_camp_6] = useState<boolean>(false);
  const [error_capacidade_campo_camp_7, set_capacidade_campo_camp_7] = useState<boolean>(false);
  const [error_teor_crit_cul_camp_1, set_teor_crit_cul_camp_1] = useState<boolean>(false);
  const [error_teor_crit_cul_camp_2, set_teor_crit_cul_camp_2] = useState<boolean>(false);
  const [error_teor_crit_cul_camp_3, set_teor_crit_cul_camp_3] = useState<boolean>(false);
  const [error_teor_crit_cul_camp_4, set_teor_crit_cul_camp_4] = useState<boolean>(false);
  const [error_teor_crit_cul_camp_5, set_teor_crit_cul_camp_5] = useState<boolean>(false);
  const [error_teor_crit_cul_camp_6, set_teor_crit_cul_camp_6] = useState<boolean>(false);
  const [error_teor_crit_cul_camp_7, set_teor_crit_cul_camp_7] = useState<boolean>(false);
  const [error_teor_agua_inicio_camp_1, set_teor_agua_inicio_camp_1] = useState<boolean>(false);
  const [error_teor_agua_inicio_camp_2, set_teor_agua_inicio_camp_2] = useState<boolean>(false);
  const [error_teor_agua_inicio_camp_3, set_teor_agua_inicio_camp_3] = useState<boolean>(false);
  const [error_teor_agua_inicio_camp_4, set_teor_agua_inicio_camp_4] = useState<boolean>(false);
  const [error_teor_agua_inicio_camp_5, set_teor_agua_inicio_camp_5] = useState<boolean>(false);
  const [error_teor_agua_inicio_camp_6, set_teor_agua_inicio_camp_6] = useState<boolean>(false);
  const [error_teor_agua_inicio_camp_7, set_teor_agua_inicio_camp_7] = useState<boolean>(false);
  const [error_eto_camp_1, set_eto_camp_1] = useState<boolean>(false);
  const [error_eto_camp_2, set_eto_camp_2] = useState<boolean>(false);
  const [error_eto_camp_3, set_eto_camp_3] = useState<boolean>(false);
  const [error_eto_camp_4, set_eto_camp_4] = useState<boolean>(false);
  const [error_eto_camp_5, set_eto_camp_5] = useState<boolean>(false);
  const [error_eto_camp_6, set_eto_camp_6] = useState<boolean>(false);
  const [error_eto_camp_7, set_eto_camp_7] = useState<boolean>(false);
  const [error_kc_camp_1, set_kc_camp_1] = useState<boolean>(false);
  const [error_kc_camp_2, set_kc_camp_2] = useState<boolean>(false);
  const [error_kc_camp_3, set_kc_camp_3] = useState<boolean>(false);
  const [error_kc_camp_4, set_kc_camp_4] = useState<boolean>(false);
  const [error_kc_camp_5, set_kc_camp_5] = useState<boolean>(false);
  const [error_kc_camp_6, set_kc_camp_6] = useState<boolean>(false);
  const [error_kc_camp_7, set_kc_camp_7] = useState<boolean>(false);
  const [error_etc_camp_1, set_etc_camp_1] = useState<boolean>(false);
  const [error_etc_camp_2, set_etc_camp_2] = useState<boolean>(false);
  const [error_etc_camp_3, set_etc_camp_3] = useState<boolean>(false);
  const [error_etc_camp_4, set_etc_camp_4] = useState<boolean>(false);
  const [error_etc_camp_5, set_etc_camp_5] = useState<boolean>(false);
  const [error_etc_camp_6, set_etc_camp_6] = useState<boolean>(false);
  const [error_etc_camp_7, set_etc_camp_7] = useState<boolean>(false);
  const [error_precipita_t_camp_1, set_precipita_t_camp_1] = useState<boolean>(false);
  const [error_precipita_t_camp_2, set_precipita_t_camp_2] = useState<boolean>(false);
  const [error_precipita_t_camp_3, set_precipita_t_camp_3] = useState<boolean>(false);
  const [error_precipita_t_camp_4, set_precipita_t_camp_4] = useState<boolean>(false);
  const [error_precipita_t_camp_5, set_precipita_t_camp_5] = useState<boolean>(false);
  const [error_precipita_t_camp_6, set_precipita_t_camp_6] = useState<boolean>(false);
  const [error_precipita_t_camp_7, set_precipita_t_camp_7] = useState<boolean>(false);
  const [error_variacao_agu_camp_1, set_variacao_agu_camp_1] = useState<boolean>(false);
  const [error_variacao_agu_camp_2, set_variacao_agu_camp_2] = useState<boolean>(false);
  const [error_variacao_agu_camp_3, set_variacao_agu_camp_3] = useState<boolean>(false);
  const [error_variacao_agu_camp_4, set_variacao_agu_camp_4] = useState<boolean>(false);
  const [error_variacao_agu_camp_5, set_variacao_agu_camp_5] = useState<boolean>(false);
  const [error_variacao_agu_camp_6, set_variacao_agu_camp_6] = useState<boolean>(false);
  const [error_variacao_agu_camp_7, set_variacao_agu_camp_7] = useState<boolean>(false);
  const [error_teor_agua_solo_s_rega_camp_1, set_teor_agua_solo_s_rega_camp_1] = useState<boolean>(false);
  const [error_teor_agua_solo_s_rega_camp_2, set_teor_agua_solo_s_rega_camp_2] = useState<boolean>(false);
  const [error_teor_agua_solo_s_rega_camp_3, set_teor_agua_solo_s_rega_camp_3] = useState<boolean>(false);
  const [error_teor_agua_solo_s_rega_camp_4, set_teor_agua_solo_s_rega_camp_4] = useState<boolean>(false);
  const [error_teor_agua_solo_s_rega_camp_5, set_teor_agua_solo_s_rega_camp_5] = useState<boolean>(false);
  const [error_teor_agua_solo_s_rega_camp_6, set_teor_agua_solo_s_rega_camp_6] = useState<boolean>(false);
  const [error_teor_agua_solo_s_rega_camp_7, set_teor_agua_solo_s_rega_camp_7] = useState<boolean>(false);
  const [error_leitura_sonda_1_camp_1, set_leitura_sonda_1_camp_1] = useState<boolean>(false);
  const [error_leitura_sonda_1_camp_2, set_leitura_sonda_1_camp_2] = useState<boolean>(false);
  const [error_leitura_sonda_1_camp_3, set_leitura_sonda_1_camp_3] = useState<boolean>(false);
  const [error_leitura_sonda_1_camp_4, set_leitura_sonda_1_camp_4] = useState<boolean>(false);
  const [error_leitura_sonda_1_camp_5, set_leitura_sonda_1_camp_5] = useState<boolean>(false);
  const [error_leitura_sonda_1_camp_6, set_leitura_sonda_1_camp_6] = useState<boolean>(false);
  const [error_leitura_sonda_1_camp_7, set_leitura_sonda_1_camp_7] = useState<boolean>(false);
  const [error_leitura_sonda_2_camp_1, set_leitura_sonda_2_camp_1] = useState<boolean>(false);
  const [error_leitura_sonda_2_camp_2, set_leitura_sonda_2_camp_2] = useState<boolean>(false);
  const [error_leitura_sonda_2_camp_3, set_leitura_sonda_2_camp_3] = useState<boolean>(false);
  const [error_leitura_sonda_2_camp_4, set_leitura_sonda_2_camp_4] = useState<boolean>(false);
  const [error_leitura_sonda_2_camp_5, set_leitura_sonda_2_camp_5] = useState<boolean>(false);
  const [error_leitura_sonda_2_camp_6, set_leitura_sonda_2_camp_6] = useState<boolean>(false);
  const [error_leitura_sonda_2_camp_7, set_leitura_sonda_2_camp_7] = useState<boolean>(false);
  const [error_folga_prox_rega_camp_1, set_folga_prox_rega_camp_1] = useState<boolean>(false);
  const [error_folga_prox_rega_camp_2, set_folga_prox_rega_camp_2] = useState<boolean>(false);
  const [error_folga_prox_rega_camp_3, set_folga_prox_rega_camp_3] = useState<boolean>(false);
  const [error_folga_prox_rega_camp_4, set_folga_prox_rega_camp_4] = useState<boolean>(false);
  const [error_folga_prox_rega_camp_5, set_folga_prox_rega_camp_5] = useState<boolean>(false);
  const [error_folga_prox_rega_camp_6, set_folga_prox_rega_camp_6] = useState<boolean>(false);
  const [error_folga_prox_rega_camp_7, set_folga_prox_rega_camp_7] = useState<boolean>(false);
  const [error_rega_leitura_camp_1, set_rega_leitura_camp_1] = useState<boolean>(false);
  const [error_rega_leitura_camp_2, set_rega_leitura_camp_2] = useState<boolean>(false);
  const [error_rega_leitura_camp_3, set_rega_leitura_camp_3] = useState<boolean>(false);
  const [error_rega_leitura_camp_4, set_rega_leitura_camp_4] = useState<boolean>(false);
  const [error_rega_leitura_camp_5, set_rega_leitura_camp_5] = useState<boolean>(false);
  const [error_rega_leitura_camp_6, set_rega_leitura_camp_6] = useState<boolean>(false);
  const [error_rega_leitura_camp_7, set_rega_leitura_camp_7] = useState<boolean>(false);
  const [error_rega_dose_total_camp_1, set_rega_dose_total_camp_1] = useState<boolean>(false);
  const [error_rega_dose_total_camp_2, set_rega_dose_total_camp_2] = useState<boolean>(false);
  const [error_rega_dose_total_camp_3, set_rega_dose_total_camp_3] = useState<boolean>(false);
  const [error_rega_dose_total_camp_4, set_rega_dose_total_camp_4] = useState<boolean>(false);
  const [error_rega_dose_total_camp_5, set_rega_dose_total_camp_5] = useState<boolean>(false);
  const [error_rega_dose_total_camp_6, set_rega_dose_total_camp_6] = useState<boolean>(false);
  const [error_rega_dose_total_camp_7, set_rega_dose_total_camp_7] = useState<boolean>(false);
  const [error_rega_dose_util_camp_1, set_rega_dose_util_camp_1] = useState<boolean>(false);
  const [error_rega_dose_util_camp_2, set_rega_dose_util_camp_2] = useState<boolean>(false);
  const [error_rega_dose_util_camp_3, set_rega_dose_util_camp_3] = useState<boolean>(false);
  const [error_rega_dose_util_camp_4, set_rega_dose_util_camp_4] = useState<boolean>(false);
  const [error_rega_dose_util_camp_5, set_rega_dose_util_camp_5] = useState<boolean>(false);
  const [error_rega_dose_util_camp_6, set_rega_dose_util_camp_6] = useState<boolean>(false);
  const [error_rega_dose_util_camp_7, set_rega_dose_util_camp_7] = useState<boolean>(false);
  const [error_teor_agua_solo_1_camp_1, set_teor_agua_solo_1_camp_1] = useState<boolean>(false);
  const [error_teor_agua_solo_1_camp_2, set_teor_agua_solo_1_camp_2] = useState<boolean>(false);
  const [error_teor_agua_solo_1_camp_3, set_teor_agua_solo_1_camp_3] = useState<boolean>(false);
  const [error_teor_agua_solo_1_camp_4, set_teor_agua_solo_1_camp_4] = useState<boolean>(false);
  const [error_teor_agua_solo_1_camp_5, set_teor_agua_solo_1_camp_5] = useState<boolean>(false);
  const [error_teor_agua_solo_1_camp_6, set_teor_agua_solo_1_camp_6] = useState<boolean>(false);
  const [error_teor_agua_solo_1_camp_7, set_teor_agua_solo_1_camp_7] = useState<boolean>(false);
  const [error_perda_agua_camp_1, set_perda_agua_camp_1] = useState<boolean>(false);
  const [error_perda_agua_camp_2, set_perda_agua_camp_2] = useState<boolean>(false);
  const [error_perda_agua_camp_3, set_perda_agua_camp_3] = useState<boolean>(false);
  const [error_perda_agua_camp_4, set_perda_agua_camp_4] = useState<boolean>(false);
  const [error_perda_agua_camp_5, set_perda_agua_camp_5] = useState<boolean>(false);
  const [error_perda_agua_camp_6, set_perda_agua_camp_6] = useState<boolean>(false);
  const [error_perda_agua_camp_7, set_perda_agua_camp_7] = useState<boolean>(false);
  const [error_ident_camp2, set_ident_camp2] = useState<boolean>(false);
  const [error_ident_camp4, set_ident_camp4] = useState<boolean>(false);
  const [valueYear, setValueYear] = useState<Dayjs | null>(null);

  const message_apenas_numero = ("Apenas números são aceites");
  const campos_NaoNumericos = ["eficiencia_rega", "mes", "semana_n", "date_camp_1", "date_camp_2", "date_camp_3", "date_camp_4", "date_camp_5", "date_camp_6", "date_camp_7", "ident_camp1", "ident_camp3"]

  const onInputChange = (event: any) => {
    const { name, value } = event.target;

    const isCampoNumerico = campos_NaoNumericos.includes(name);
    set_flag_editado(true)


    if (!isCampoNumerico) {
      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      const valorNumerico = parseFloat(value.replace(",", "."));

      if (!isNaN(valorNumerico)) {
        if (name === "prefundidad_radi_camp_1") {
          set_prefundidad_radi_camp_1(false);
        } else if (name === "prefundidad_radi_camp_2") {
          set_prefundidad_radi_camp_2(false);
        } else if (name === "prefundidad_radi_camp_3") {
          set_prefundidad_radi_camp_3(false);
        } if (name === "prefundidad_radi_camp_4") {
          set_prefundidad_radi_camp_4(false);
        } else if (name === "prefundidad_radi_camp_5") {
          set_prefundidad_radi_camp_5(false);
        } else if (name === "prefundidad_radi_camp_6") {
          set_prefundidad_radi_camp_6(false);
        } else if (name === "prefundidad_radi_camp_7") {
          set_prefundidad_radi_camp_7(false);
        } else if (name === "capacidade_campo_camp_1") {
          set_capacidade_campo_camp_1(false);
        } else if (name === "capacidade_campo_camp_2") {
          set_capacidade_campo_camp_2(false);
        } else if (name === "capacidade_campo_camp_3") {
          set_capacidade_campo_camp_3(false);
        } else if (name === "capacidade_campo_camp_4") {
          set_capacidade_campo_camp_4(false);
        } else if (name === "capacidade_campo_camp_5") {
          set_capacidade_campo_camp_5(false);
        } else if (name === "capacidade_campo_camp_6") {
          set_capacidade_campo_camp_6(false);
        } else if (name === "capacidade_campo_camp_7") {
          set_capacidade_campo_camp_7(false);
        } else if (name === "teor_crit_cul_camp_1") {
          set_teor_crit_cul_camp_1(false);
        } else if (name === "teor_crit_cul_camp_2") {
          set_teor_crit_cul_camp_2(false);
        } else if (name === "teor_crit_cul_camp_3") {
          set_teor_crit_cul_camp_3(false);
        } else if (name === "teor_crit_cul_camp_4") {
          set_teor_crit_cul_camp_4(false);
        } else if (name === "teor_crit_cul_camp_5") {
          set_teor_crit_cul_camp_5(false);
        } else if (name === "teor_crit_cul_camp_6") {
          set_teor_crit_cul_camp_6(false);
        } else if (name === "teor_crit_cul_camp_7") {
          set_teor_crit_cul_camp_7(false);
        } else if (name === "teor_agua_inicio_camp_1") {
          set_teor_agua_inicio_camp_1(false);
        } else if (name === "teor_agua_inicio_camp_2") {
          set_teor_agua_inicio_camp_2(false);
        } else if (name === "teor_agua_inicio_camp_3") {
          set_teor_agua_inicio_camp_3(false);
        } else if (name === "teor_agua_inicio_camp_4") {
          set_teor_agua_inicio_camp_4(false);
        } else if (name === "teor_agua_inicio_camp_5") {
          set_teor_agua_inicio_camp_5(false);
        } else if (name === "teor_agua_inicio_camp_6") {
          set_teor_agua_inicio_camp_6(false);
        } else if (name === "teor_agua_inicio_camp_7") {
          set_teor_agua_inicio_camp_7(false);
        } else if (name === "eto_camp_1") {
          set_eto_camp_1(false);
        } else if (name === "eto_camp_2") {
          set_eto_camp_2(false);
        } else if (name === "eto_camp_3") {
          set_eto_camp_3(false);
        } else if (name === "eto_camp_4") {
          set_eto_camp_4(false);
        } else if (name === "eto_camp_5") {
          set_eto_camp_5(false);
        } else if (name === "eto_camp_6") {
          set_eto_camp_6(false);
        } else if (name === "eto_camp_7") {
          set_eto_camp_7(false);
        } else if (name === "kc_camp_1") {
          set_kc_camp_1(false);
        } else if (name === "kc_camp_2") {
          set_kc_camp_2(false);
        } else if (name === "kc_camp_3") {
          set_kc_camp_3(false);
        } else if (name === "kc_camp_4") {
          set_kc_camp_4(false);
        } else if (name === "kc_camp_5") {
          set_kc_camp_5(false);
        } else if (name === "kc_camp_6") {
          set_kc_camp_6(false);
        } else if (name === "kc_camp_7") {
          set_kc_camp_7(false);
        } else if (name === "etc_camp_1") {
          set_etc_camp_1(false);
        } else if (name === "etc_camp_2") {
          set_etc_camp_2(false);
        } else if (name === "etc_camp_3") {
          set_etc_camp_3(false);
        } else if (name === "etc_camp_4") {
          set_etc_camp_4(false);
        } else if (name === "etc_camp_5") {
          set_etc_camp_5(false);
        } else if (name === "etc_camp_6") {
          set_etc_camp_6(false);
        } else if (name === "etc_camp_7") {
          set_etc_camp_7(false);
        } else if (name === "precipita_t_camp_1") {
          set_precipita_t_camp_1(false);
        } else if (name === "precipita_t_camp_2") {
          set_precipita_t_camp_2(false);
        } else if (name === "precipita_t_camp_3") {
          set_precipita_t_camp_3(false);
        } else if (name === "precipita_t_camp_4") {
          set_precipita_t_camp_4(false);
        } else if (name === "precipita_t_camp_5") {
          set_precipita_t_camp_5(false);
        } else if (name === "precipita_t_camp_6") {
          set_precipita_t_camp_6(false);
        } else if (name === "precipita_t_camp_7") {
          set_precipita_t_camp_7(false);
        } else if (name === "variacao_agu_camp_1") {
          set_variacao_agu_camp_1(false);
        } else if (name === "variacao_agu_camp_2") {
          set_variacao_agu_camp_2(false);
        } else if (name === "variacao_agu_camp_3") {
          set_variacao_agu_camp_3(false);
        } else if (name === "variacao_agu_camp_4") {
          set_variacao_agu_camp_4(false);
        } else if (name === "variacao_agu_camp_5") {
          set_variacao_agu_camp_5(false);
        } else if (name === "variacao_agu_camp_6") {
          set_variacao_agu_camp_6(false);
        } else if (name === "variacao_agu_camp_7") {
          set_variacao_agu_camp_7(false);
        } else if (name === "teor_agua_solo_s_rega_camp_1") {
          set_teor_agua_solo_s_rega_camp_1(false);
        } else if (name === "teor_agua_solo_s_rega_camp_2") {
          set_teor_agua_solo_s_rega_camp_2(false);
        } else if (name === "teor_agua_solo_s_rega_camp_3") {
          set_teor_agua_solo_s_rega_camp_3(false);
        } else if (name === "teor_agua_solo_s_rega_camp_4") {
          set_teor_agua_solo_s_rega_camp_4(false);
        } else if (name === "teor_agua_solo_s_rega_camp_5") {
          set_teor_agua_solo_s_rega_camp_5(false);
        } else if (name === "teor_agua_solo_s_rega_camp_6") {
          set_teor_agua_solo_s_rega_camp_6(false);
        } else if (name === "teor_agua_solo_s_rega_camp_7") {
          set_teor_agua_solo_s_rega_camp_7(false);
        } else if (name === "leitura_sonda_1_camp_1") {
          set_leitura_sonda_1_camp_1(false);
        } else if (name === "leitura_sonda_1_camp_2") {
          set_leitura_sonda_1_camp_2(false);
        } else if (name === "leitura_sonda_1_camp_3") {
          set_leitura_sonda_1_camp_3(false);
        } else if (name === "leitura_sonda_1_camp_4") {
          set_leitura_sonda_1_camp_4(false);
        } else if (name === "leitura_sonda_1_camp_5") {
          set_leitura_sonda_1_camp_5(false);
        } else if (name === "leitura_sonda_1_camp_6") {
          set_leitura_sonda_1_camp_6(false);
        } else if (name === "leitura_sonda_1_camp_7") {
          set_leitura_sonda_1_camp_7(false);
        } else if (name === "leitura_sonda_2_camp_1") {
          set_leitura_sonda_2_camp_1(false);
        } else if (name === "leitura_sonda_2_camp_2") {
          set_leitura_sonda_2_camp_2(false);
        } else if (name === "leitura_sonda_2_camp_3") {
          set_leitura_sonda_2_camp_3(false);
        } else if (name === "leitura_sonda_2_camp_4") {
          set_leitura_sonda_2_camp_4(false);
        } else if (name === "leitura_sonda_2_camp_5") {
          set_leitura_sonda_2_camp_5(false);
        } else if (name === "leitura_sonda_2_camp_6") {
          set_leitura_sonda_2_camp_6(false);
        } else if (name === "leitura_sonda_2_camp_7") {
          set_leitura_sonda_2_camp_7(false);
        } else if (name === "folga_prox_rega_camp_1") {
          set_folga_prox_rega_camp_1(false);
        } else if (name === "folga_prox_rega_camp_2") {
          set_folga_prox_rega_camp_2(false);
        } else if (name === "folga_prox_rega_camp_3") {
          set_folga_prox_rega_camp_3(false);
        } else if (name === "folga_prox_rega_camp_4") {
          set_folga_prox_rega_camp_4(false);
        } else if (name === "folga_prox_rega_camp_5") {
          set_folga_prox_rega_camp_5(false);
        } else if (name === "folga_prox_rega_camp_6") {
          set_folga_prox_rega_camp_6(false);
        } else if (name === "folga_prox_rega_camp_7") {
          set_folga_prox_rega_camp_7(false);
        } else if (name === "rega_leitura_camp_1") {
          set_rega_leitura_camp_1(false);
        } else if (name === "rega_leitura_camp_2") {
          set_rega_leitura_camp_2(false);
        } else if (name === "rega_leitura_camp_3") {
          set_rega_leitura_camp_3(false);
        } else if (name === "rega_leitura_camp_4") {
          set_rega_leitura_camp_4(false);
        } else if (name === "rega_leitura_camp_5") {
          set_rega_leitura_camp_5(false);
        } else if (name === "rega_leitura_camp_6") {
          set_rega_leitura_camp_6(false);
        } else if (name === "rega_leitura_camp_7") {
          set_rega_leitura_camp_7(false);
        } else if (name === "rega_dose_total_camp_1") {
          set_rega_dose_total_camp_1(false);
        } else if (name === "rega_dose_total_camp_2") {
          set_rega_dose_total_camp_2(false);
        } else if (name === "rega_dose_total_camp_3") {
          set_rega_dose_total_camp_3(false);
        } else if (name === "rega_dose_total_camp_4") {
          set_rega_dose_total_camp_4(false);
        } else if (name === "rega_dose_total_camp_5") {
          set_rega_dose_total_camp_5(false);
        } else if (name === "rega_dose_total_camp_6") {
          set_rega_dose_total_camp_6(false);
        } else if (name === "rega_dose_total_camp_7") {
          set_rega_dose_total_camp_7(false);
        } else if (name === "rega_dose_util_camp_1") {
          set_rega_dose_util_camp_1(false);
        } else if (name === "rega_dose_util_camp_2") {
          set_rega_dose_util_camp_2(false);
        } else if (name === "rega_dose_util_camp_3") {
          set_rega_dose_util_camp_3(false);
        } else if (name === "rega_dose_util_camp_4") {
          set_rega_dose_util_camp_4(false);
        } else if (name === "rega_dose_util_camp_5") {
          set_rega_dose_util_camp_5(false);
        } else if (name === "rega_dose_util_camp_6") {
          set_rega_dose_util_camp_6(false);
        } else if (name === "rega_dose_util_camp_7") {
          set_rega_dose_util_camp_7(false);
        } else if (name === "teor_agua_solo_1_camp_1") {
          set_teor_agua_solo_1_camp_1(false);
        } else if (name === "teor_agua_solo_1_camp_2") {
          set_teor_agua_solo_1_camp_2(false);
        } else if (name === "teor_agua_solo_1_camp_3") {
          set_teor_agua_solo_1_camp_3(false);
        } else if (name === "teor_agua_solo_1_camp_4") {
          set_teor_agua_solo_1_camp_4(false);
        } else if (name === "teor_agua_solo_1_camp_5") {
          set_teor_agua_solo_1_camp_5(false);
        } else if (name === "teor_agua_solo_1_camp_6") {
          set_teor_agua_solo_1_camp_6(false);
        } else if (name === "teor_agua_solo_1_camp_7") {
          set_teor_agua_solo_1_camp_7(false);
        } else if (name === "perda_agua_camp_1") {
          set_perda_agua_camp_1(false);
        } else if (name === "perda_agua_camp_2") {
          set_perda_agua_camp_2(false);
        } else if (name === "perda_aguacamp_3") {
          set_perda_agua_camp_3(false);
        } else if (name === "perda_agua_camp_4") {
          set_perda_agua_camp_4(false);
        } else if (name === "perda_agua_camp_5") {
          set_perda_agua_camp_5(false);
        } else if (name === "perda_agua_camp_6") {
          set_perda_agua_camp_6(false);
        } else if (name === "perda_agua_camp_7") {
          set_perda_agua_camp_7(false);
        } else if (name === "ident_camp2") {
          set_ident_camp2(false);
        } else if (name === "ident_camp4") {
          set_ident_camp4(false);
        } else if (name === "capacidade_utili") {
          set_capacidade_utili(false);
        } else if (name === "reserva_facilmente_utiliz") {
          set_reserva_facilmente_utiliz(false);
        }

      } else {
        if (name === "prefundidad_radi_camp_1") {
          set_prefundidad_radi_camp_1(true);
        } else if (name === "prefundidad_radi_camp_2") {
          set_prefundidad_radi_camp_2(true);
        } else if (name === "prefundidad_radi_camp_3") {
          set_prefundidad_radi_camp_3(true);
        } if (name === "prefundidad_radi_camp_4") {
          set_prefundidad_radi_camp_4(true);
        } else if (name === "prefundidad_radi_camp_5") {
          set_prefundidad_radi_camp_5(true);
        } else if (name === "prefundidad_radi_camp_6") {
          set_prefundidad_radi_camp_6(true);
        } else if (name === "prefundidad_radi_camp_7") {
          set_prefundidad_radi_camp_7(true);
        } else if (name === "capacidade_campo_camp_1") {
          set_capacidade_campo_camp_1(true);
        } else if (name === "capacidade_campo_camp_2") {
          set_capacidade_campo_camp_2(true);
        } else if (name === "capacidade_campo_camp_3") {
          set_capacidade_campo_camp_3(true);
        } else if (name === "capacidade_campo_camp_4") {
          set_capacidade_campo_camp_4(true);
        } else if (name === "capacidade_campo_camp_5") {
          set_capacidade_campo_camp_5(true);
        } else if (name === "capacidade_campo_camp_6") {
          set_capacidade_campo_camp_6(true);
        } else if (name === "capacidade_campo_camp_7") {
          set_capacidade_campo_camp_7(true);
        } else if (name === "teor_crit_cul_camp_1") {
          set_teor_crit_cul_camp_1(true);
        } else if (name === "teor_crit_cul_camp_2") {
          set_teor_crit_cul_camp_2(true);
        } else if (name === "teor_crit_cul_camp_3") {
          set_teor_crit_cul_camp_3(true);
        } else if (name === "teor_crit_cul_camp_4") {
          set_teor_crit_cul_camp_4(true);
        } else if (name === "teor_crit_cul_camp_5") {
          set_teor_crit_cul_camp_5(true);
        } else if (name === "teor_crit_cul_camp_6") {
          set_teor_crit_cul_camp_6(true);
        } else if (name === "teor_crit_cul_camp_7") {
          set_teor_crit_cul_camp_7(true);
        } else if (name === "teor_agua_inicio_camp_1") {
          set_teor_agua_inicio_camp_1(true);
        } else if (name === "teor_agua_inicio_camp_2") {
          set_teor_agua_inicio_camp_2(true);
        } else if (name === "teor_agua_inicio_camp_3") {
          set_teor_agua_inicio_camp_3(true);
        } else if (name === "teor_agua_inicio_camp_4") {
          set_teor_agua_inicio_camp_4(true);
        } else if (name === "teor_agua_inicio_camp_5") {
          set_teor_agua_inicio_camp_5(true);
        } else if (name === "teor_agua_inicio_camp_6") {
          set_teor_agua_inicio_camp_6(true);
        } else if (name === "teor_agua_inicio_camp_7") {
          set_teor_agua_inicio_camp_7(true);
        } else if (name === "eto_camp_1") {
          set_eto_camp_1(true);
        } else if (name === "eto_camp_2") {
          set_eto_camp_2(true);
        } else if (name === "eto_camp_3") {
          set_eto_camp_3(true);
        } else if (name === "eto_camp_4") {
          set_eto_camp_4(true);
        } else if (name === "eto_camp_5") {
          set_eto_camp_5(true);
        } else if (name === "eto_camp_6") {
          set_eto_camp_6(true);
        } else if (name === "eto_camp_7") {
          set_eto_camp_7(true);
        } else if (name === "kc_camp_1") {
          set_kc_camp_1(true);
        } else if (name === "kc_camp_2") {
          set_kc_camp_2(true);
        } else if (name === "kc_camp_3") {
          set_kc_camp_3(true);
        } else if (name === "kc_camp_4") {
          set_kc_camp_4(true);
        } else if (name === "kc_camp_5") {
          set_kc_camp_5(true);
        } else if (name === "kc_camp_6") {
          set_kc_camp_6(true);
        } else if (name === "kc_camp_7") {
          set_kc_camp_7(true);
        } else if (name === "etc_camp_1") {
          set_etc_camp_1(true);
        } else if (name === "etc_camp_2") {
          set_etc_camp_2(true);
        } else if (name === "etc_camp_3") {
          set_etc_camp_3(true);
        } else if (name === "etc_camp_4") {
          set_etc_camp_4(true);
        } else if (name === "etc_camp_5") {
          set_etc_camp_5(true);
        } else if (name === "etc_camp_6") {
          set_etc_camp_6(true);
        } else if (name === "etc_camp_7") {
          set_etc_camp_7(true);
        } else if (name === "precipita_t_camp_1") {
          set_precipita_t_camp_1(true);
        } else if (name === "precipita_t_camp_2") {
          set_precipita_t_camp_2(true);
        } else if (name === "precipita_t_camp_3") {
          set_precipita_t_camp_3(true);
        } else if (name === "precipita_t_camp_4") {
          set_precipita_t_camp_4(true);
        } else if (name === "precipita_t_camp_5") {
          set_precipita_t_camp_5(true);
        } else if (name === "precipita_t_camp_6") {
          set_precipita_t_camp_6(true);
        } else if (name === "precipita_t_camp_7") {
          set_precipita_t_camp_7(true);
        } else if (name === "variacao_agu_camp_1") {
          set_variacao_agu_camp_1(true);
        } else if (name === "variacao_agu_camp_2") {
          set_variacao_agu_camp_2(true);
        } else if (name === "variacao_agu_camp_3") {
          set_variacao_agu_camp_3(true);
        } else if (name === "variacao_agu_camp_4") {
          set_variacao_agu_camp_4(true);
        } else if (name === "variacao_agu_camp_5") {
          set_variacao_agu_camp_5(true);
        } else if (name === "variacao_agu_camp_6") {
          set_variacao_agu_camp_6(true);
        } else if (name === "variacao_agu_camp_7") {
          set_variacao_agu_camp_7(true);
        } else if (name === "teor_agua_solo_s_rega_camp_1") {
          set_teor_agua_solo_s_rega_camp_1(true);
        } else if (name === "teor_agua_solo_s_rega_camp_2") {
          set_teor_agua_solo_s_rega_camp_2(true);
        } else if (name === "teor_agua_solo_s_rega_camp_3") {
          set_teor_agua_solo_s_rega_camp_3(true);
        } else if (name === "teor_agua_solo_s_rega_camp_4") {
          set_teor_agua_solo_s_rega_camp_4(true);
        } else if (name === "teor_agua_solo_s_rega_camp_5") {
          set_teor_agua_solo_s_rega_camp_5(true);
        } else if (name === "teor_agua_solo_s_rega_camp_6") {
          set_teor_agua_solo_s_rega_camp_6(true);
        } else if (name === "teor_agua_solo_s_rega_camp_7") {
          set_teor_agua_solo_s_rega_camp_7(true);
        } else if (name === "leitura_sonda_1_camp_1") {
          set_leitura_sonda_1_camp_1(true);
        } else if (name === "leitura_sonda_1_camp_2") {
          set_leitura_sonda_1_camp_2(true);
        } else if (name === "leitura_sonda_1_camp_3") {
          set_leitura_sonda_1_camp_3(true);
        } else if (name === "leitura_sonda_1_camp_4") {
          set_leitura_sonda_1_camp_4(true);
        } else if (name === "leitura_sonda_1_camp_5") {
          set_leitura_sonda_1_camp_5(true);
        } else if (name === "leitura_sonda_1_camp_6") {
          set_leitura_sonda_1_camp_6(true);
        } else if (name === "leitura_sonda_1_camp_7") {
          set_leitura_sonda_1_camp_7(true);
        } else if (name === "leitura_sonda_2_camp_1") {
          set_leitura_sonda_2_camp_1(true);
        } else if (name === "leitura_sonda_2_camp_2") {
          set_leitura_sonda_2_camp_2(true);
        } else if (name === "leitura_sonda_2_camp_3") {
          set_leitura_sonda_2_camp_3(true);
        } else if (name === "leitura_sonda_2_camp_4") {
          set_leitura_sonda_2_camp_4(true);
        } else if (name === "leitura_sonda_2_camp_5") {
          set_leitura_sonda_2_camp_5(true);
        } else if (name === "leitura_sonda_2_camp_6") {
          set_leitura_sonda_2_camp_6(true);
        } else if (name === "leitura_sonda_2_camp_7") {
          set_leitura_sonda_2_camp_7(true);
        } else if (name === "folga_prox_rega_camp_1") {
          set_folga_prox_rega_camp_1(true);
        } else if (name === "folga_prox_rega_camp_2") {
          set_folga_prox_rega_camp_2(true);
        } else if (name === "folga_prox_rega_camp_3") {
          set_folga_prox_rega_camp_3(true);
        } else if (name === "folga_prox_rega_camp_4") {
          set_folga_prox_rega_camp_4(true);
        } else if (name === "folga_prox_rega_camp_5") {
          set_folga_prox_rega_camp_5(true);
        } else if (name === "folga_prox_rega_camp_6") {
          set_folga_prox_rega_camp_6(true);
        } else if (name === "folga_prox_rega_camp_7") {
          set_folga_prox_rega_camp_7(true);
        } else if (name === "rega_leitura_camp_1") {
          set_rega_leitura_camp_1(true);
        } else if (name === "rega_leitura_camp_2") {
          set_rega_leitura_camp_2(true);
        } else if (name === "rega_leitura_camp_3") {
          set_rega_leitura_camp_3(true);
        } else if (name === "rega_leitura_camp_4") {
          set_rega_leitura_camp_4(true);
        } else if (name === "rega_leitura_camp_5") {
          set_rega_leitura_camp_5(true);
        } else if (name === "rega_leitura_camp_6") {
          set_rega_leitura_camp_6(true);
        } else if (name === "rega_leitura_camp_7") {
          set_rega_leitura_camp_7(true);
        } else if (name === "rega_dose_total_camp_1") {
          set_rega_dose_total_camp_1(true);
        } else if (name === "rega_dose_total_camp_2") {
          set_rega_dose_total_camp_2(true);
        } else if (name === "rega_dose_total_camp_3") {
          set_rega_dose_total_camp_3(true);
        } else if (name === "rega_dose_total_camp_4") {
          set_rega_dose_total_camp_4(true);
        } else if (name === "rega_dose_total_camp_5") {
          set_rega_dose_total_camp_5(true);
        } else if (name === "rega_dose_total_camp_6") {
          set_rega_dose_total_camp_6(true);
        } else if (name === "rega_dose_total_camp_7") {
          set_rega_dose_total_camp_7(true);
        } else if (name === "rega_dose_util_camp_1") {
          set_rega_dose_util_camp_1(true);
        } else if (name === "rega_dose_util_camp_2") {
          set_rega_dose_util_camp_2(true);
        } else if (name === "rega_dose_util_camp_3") {
          set_rega_dose_util_camp_3(true);
        } else if (name === "rega_dose_util_camp_4") {
          set_rega_dose_util_camp_4(true);
        } else if (name === "rega_dose_util_camp_5") {
          set_rega_dose_util_camp_5(true);
        } else if (name === "rega_dose_util_camp_6") {
          set_rega_dose_util_camp_6(true);
        } else if (name === "rega_dose_util_camp_7") {
          set_rega_dose_util_camp_7(true);
        } else if (name === "teor_agua_solo_1_camp_1") {
          set_teor_agua_solo_1_camp_1(true);
        } else if (name === "teor_agua_solo_1_camp_2") {
          set_teor_agua_solo_1_camp_2(true);
        } else if (name === "teor_agua_solo_1_camp_3") {
          set_teor_agua_solo_1_camp_3(true);
        } else if (name === "teor_agua_solo_1_camp_4") {
          set_teor_agua_solo_1_camp_4(true);
        } else if (name === "teor_agua_solo_1_camp_5") {
          set_teor_agua_solo_1_camp_5(true);
        } else if (name === "teor_agua_solo_1_camp_6") {
          set_teor_agua_solo_1_camp_6(true);
        } else if (name === "teor_agua_solo_1_camp_7") {
          set_teor_agua_solo_1_camp_7(true);
        } else if (name === "perda_agua_camp_1") {
          set_perda_agua_camp_1(true);
        } else if (name === "perda_agua_camp_2") {
          set_perda_agua_camp_2(true);
        } else if (name === "perda_aguacamp_3") {
          set_perda_agua_camp_3(true);
        } else if (name === "perda_agua_camp_4") {
          set_perda_agua_camp_4(true);
        } else if (name === "perda_agua_camp_5") {
          set_perda_agua_camp_5(true);
        } else if (name === "perda_agua_camp_6") {
          set_perda_agua_camp_6(true);
        } else if (name === "perda_agua_camp_7") {
          set_perda_agua_camp_7(true);
        } else if (name === "ident_camp2") {
          set_ident_camp2(true);
        } else if (name === "ident_camp4") {
          set_ident_camp4(true);
        } else if (name === "capacidade_utili") {
          set_capacidade_utili(true);
        } else if (name === "reserva_facilmente_utiliz") {
          set_reserva_facilmente_utiliz(true);
        }

      }


      setTabela((prev: any) => ({
        ...prev,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else {
      if (name === "mes") {

        set_date_camp_1_default(undefined)
        set_date_camp_2_default(undefined)
        set_date_camp_3_default(undefined)
        set_date_camp_4_default(undefined)
        set_date_camp_5_default(undefined)
        set_date_camp_6_default(undefined)
        set_date_camp_7_default(undefined)

        setTabela((prev: any) => ({
          ...prev,
          [name]: value,
          ['semana_n']: undefined,
          ['date_camp_1']: undefined,
          ['date_camp_2']: undefined,
          ['date_camp_3']: undefined,
          ['date_camp_4']: undefined,
          ['date_camp_5']: undefined,
          ['date_camp_6']: undefined,
          ['date_camp_7']: undefined,
        }));
      } else {
        setTabela((prev: any) => ({
          ...prev,
          [name]: value,
        }));
      }

    }
  };

  return (
    <>

      <TableRow>
        <StyledTableHeadLeft>
          Capacidade utilizável (m3/m3):
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="capacidade_utili"
            value={tabela?.capacidade_utili === undefined ? "" : tabela.capacidade_utili}
            onChange={onInputChange}
            error={error_capacidade_utili}
            helperText={error_capacidade_utili ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft colSpan={2} rowSpan={2}>
          Eficiência da rega:
          <CustomTextField
            value={tabela?.eficiencia_rega === undefined ? "" : tabela.eficiencia_rega}
            name="eficiencia_rega"
            onChange={onInputChange}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft colSpan={2} rowSpan={2}>

          <Stack direction="column" justifyContent="start">
            Mês:
            <CustomSelect
              value={tabela?.mes === undefined ? (mes_default !== undefined ? mes_default : '') : tabela?.mes}
              name="mes"
              onChange={onInputChange}
              options={meses_ano}
              label=""

            />
          </Stack>

        </StyledTableHeadLeft>
        <StyledTableHeadLeft rowSpan={2} colSpan={2}>Semana n.º:
          <Stack direction="row" justifyContent="start">
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt"  >
              <DatePicker
                name="semana_n"
                dayOfWeekFormatter={(weekday) => `${weekday.format('dd')}`}
                fixedWeekNumber={1}
                displayWeekNumber
                format={valueYear === null ? `${dayjs(date_camp_1_default).format("ww")}` : `${dayjs(valueYear).format("ww")}`}
                value={valueYear === null ? date_camp_1_default === undefined ? null : dayjs(date_camp_1_default) : valueYear}
                onChange={(value) => {
                  if (value) {
                    setValueYear(value);
                    const data_aux = new Date(value.format('YYYY/MM/DD'))
                    const dia_da_semana_selecionada = (data_aux.getDay() + 6) % 7
                    const dia = dayjs(data_aux)

                    const dia_1 = dia_da_semana_selecionada === 0 ? dia : dia.subtract(dia_da_semana_selecionada, 'day')
                    const dia_2 = dia_1.add(1, 'day')
                    const dia_3 = dia_1.add(2, 'day')
                    const dia_4 = dia_1.add(3, 'day')
                    const dia_5 = dia_1.add(4, 'day')
                    const dia_6 = dia_1.add(5, 'day')
                    const dia_7 = dia_1.add(6, 'day')

                    setTabela((prev: any) => ({
                      ...prev,
                      semana_n: value.format("ww"),
                      mes: meses_ano[value.month()],
                      date_camp_1: dia_1.format("YYYY/MM/DD"),
                      date_camp_2: dia_2.format("YYYY/MM/DD"),
                      date_camp_3: dia_3.format("YYYY/MM/DD"),
                      date_camp_4: dia_4.format("YYYY/MM/DD"),
                      date_camp_5: dia_5.format("YYYY/MM/DD"),
                      date_camp_6: dia_6.format("YYYY/MM/DD"),
                      date_camp_7: dia_7.format("YYYY/MM/DD"),
                    }));


                  }

                }}
              />
            </LocalizationProvider>
            <BasicPopover
              text={"Preencher com o n.º da semana ao qual\n diz respeito o calendário de rega e ano cívil"} />
          </Stack>
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft> Reserva facilmente utilizável (m3/m3): </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            value={tabela?.reserva_facilmente_utiliz === undefined ? "" : tabela.reserva_facilmente_utiliz}
            name="reserva_facilmente_utiliz"
            onChange={onInputChange}
            error={error_reserva_facilmente_utiliz}
            helperText={error_reserva_facilmente_utiliz ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <TableCell></TableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>
          <Stack direction="row" justifyContent="end" alignItems="center">
            Data
            <BasicPopover text={"Identificar, em cada um dos campos seguintes o dia da semana, dia do mês e mês"} />
          </Stack>
        </StyledTableHeadLeft>
        <StyledTableHeadLeft  >
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt">
            <DatePicker
              name="date_camp_1"
              format="DD MMM, ddd"
              value={tabela?.date_camp_1 === undefined ? dayjs(date_camp_1_default) : dayjs(tabela.date_camp_1)}
              onChange={(value) => {

                setTabela((prev: any) => ({
                  ...prev,
                  date_camp_1: value?.format("YYYY/MM/DD"),
                }));
              }}
            />
          </LocalizationProvider>
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt">
            <DatePicker
              name="date_camp_2"
              format="DD MMM, ddd"
              value={tabela?.date_camp_2 === undefined ? dayjs(date_camp_2_default) : dayjs(tabela.date_camp_2)}
              onChange={(value) => {

                setTabela((prev: any) => ({
                  ...prev,
                  date_camp_2: value?.format("YYYY/MM/DD"),
                }));
              }}
            />
          </LocalizationProvider>
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt">
            <DatePicker
              name="date_camp_3"
              format="DD MMM, ddd"
              value={tabela?.date_camp_3 === undefined ? dayjs(date_camp_3_default) : dayjs(tabela.date_camp_3)}
              onChange={(value) => {

                setTabela((prev: any) => ({
                  ...prev,
                  date_camp_3: value?.format("YYYY/MM/DD"),
                }));
              }}
            />
          </LocalizationProvider>
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt">
            <DatePicker
              name="date_camp_4"
              format="DD MMM, ddd"
              value={tabela?.date_camp_4 === undefined ? dayjs(date_camp_4_default) : dayjs(tabela.date_camp_4)}
              onChange={(value) => {

                setTabela((prev: any) => ({
                  ...prev,
                  date_camp_4: value?.format("YYYY/MM/DD"),
                }));
              }}
            />
          </LocalizationProvider>
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt">
            <DatePicker
              name="date_camp_5"
              format="DD MMM, ddd"
              value={tabela?.date_camp_5 === undefined ? dayjs(date_camp_5_default) : dayjs(tabela.date_camp_5)}
              onChange={(value) => {

                setTabela((prev: any) => ({
                  ...prev,
                  date_camp_5: value?.format("YYYY/MM/DD"),
                }));
              }}
            />
          </LocalizationProvider>
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt">
            <DatePicker
              name="date_camp_6"
              format="DD MMM, ddd"
              value={tabela?.date_camp_6 === undefined ? dayjs(date_camp_6_default) : dayjs(tabela.date_camp_6)}
              onChange={(value) => {

                setTabela((prev: any) => ({
                  ...prev,
                  date_camp_6: value?.format("YYYY/MM/DD"),
                }));
              }}
            />
          </LocalizationProvider>
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt">
            <DatePicker
              name="date_camp_7"
              format="DD MMM, ddd"
              value={tabela?.date_camp_7 === undefined ? dayjs(date_camp_7_default) : dayjs(tabela.date_camp_7)}
              onChange={(value) => {

                setTabela((prev: any) => ({
                  ...prev,
                  date_camp_7: value?.format("YYYY/MM/DD"),
                }));
              }}
            />
          </LocalizationProvider>
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>
          <Stack direction="row" justifyContent="end">
            DIA DO CICLO VEGETATIVO
          </Stack>
        </StyledTableHeadLeft>
        <StyledTableHeadLeft></StyledTableHeadLeft>
        <StyledTableHeadLeft></StyledTableHeadLeft>
        <StyledTableHeadLeft></StyledTableHeadLeft>
        <StyledTableHeadLeft></StyledTableHeadLeft>
        <StyledTableHeadLeft></StyledTableHeadLeft>
        <StyledTableHeadLeft></StyledTableHeadLeft>
        <StyledTableHeadLeft></StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft> PROFUNDIDADE RADICULAR (m) </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="prefundidad_radi_camp_1"
            value={tabela?.prefundidad_radi_camp_1 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.prefundidad_radi_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_prefundidad_radi_camp_1}
            helperText={error_prefundidad_radi_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="prefundidad_radi_camp_2"
            value={tabela?.prefundidad_radi_camp_2 === undefined || tabela?.prefundidad_radi_camp_2 === null ? "" : tabela.prefundidad_radi_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_prefundidad_radi_camp_2}
            helperText={error_prefundidad_radi_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="prefundidad_radi_camp_3"
            value={tabela?.prefundidad_radi_camp_3 === undefined || tabela?.prefundidad_radi_camp_3 === null ? "" : tabela.prefundidad_radi_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_prefundidad_radi_camp_3}
            helperText={error_prefundidad_radi_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="prefundidad_radi_camp_4"
            value={tabela?.prefundidad_radi_camp_4 === undefined || tabela?.prefundidad_radi_camp_4 === null ? "" : tabela.prefundidad_radi_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_prefundidad_radi_camp_4}
            helperText={error_prefundidad_radi_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="prefundidad_radi_camp_5"
            value={tabela?.prefundidad_radi_camp_5 === undefined || tabela?.prefundidad_radi_camp_5 === null ? "" : tabela.prefundidad_radi_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_prefundidad_radi_camp_5}
            helperText={error_prefundidad_radi_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="prefundidad_radi_camp_6"
            value={tabela?.prefundidad_radi_camp_6 === undefined || tabela?.prefundidad_radi_camp_6 === null ? "" : tabela.prefundidad_radi_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_prefundidad_radi_camp_6}
            helperText={error_prefundidad_radi_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="prefundidad_radi_camp_7"
            value={tabela?.prefundidad_radi_camp_7 === undefined || tabela?.prefundidad_radi_camp_7 === null ? "" : tabela.prefundidad_radi_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_prefundidad_radi_camp_7}
            helperText={error_prefundidad_radi_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>  CAPACIDADE DE CAMPO (mm) </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="capacidade_campo_camp_1"
            value={tabela?.capacidade_campo_camp_1 === undefined || tabela?.capacidade_campo_camp_1 === null ? "" : tabela.capacidade_campo_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_capacidade_campo_camp_1}
            helperText={error_capacidade_campo_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="capacidade_campo_camp_2"
            value={tabela?.capacidade_campo_camp_2 === undefined || tabela?.capacidade_campo_camp_2 === null ? "" : tabela.capacidade_campo_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_capacidade_campo_camp_2}
            helperText={error_capacidade_campo_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="capacidade_campo_camp_3"
            value={tabela?.capacidade_campo_camp_3 === undefined || tabela?.capacidade_campo_camp_3 === null ? "" : tabela.capacidade_campo_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_capacidade_campo_camp_3}
            helperText={error_capacidade_campo_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="capacidade_campo_camp_4"
            value={tabela?.capacidade_campo_camp_4 === undefined || tabela?.capacidade_campo_camp_4 === null ? "" : tabela.capacidade_campo_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_capacidade_campo_camp_4}
            helperText={error_capacidade_campo_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="capacidade_campo_camp_5"
            value={tabela?.capacidade_campo_camp_5 === undefined || tabela?.capacidade_campo_camp_5 === null ? "" : tabela.capacidade_campo_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_capacidade_campo_camp_5}
            helperText={error_capacidade_campo_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="capacidade_campo_camp_6"
            value={tabela?.capacidade_campo_camp_6 === undefined || tabela?.capacidade_campo_camp_6 === null ? "" : tabela.capacidade_campo_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_capacidade_campo_camp_6}
            helperText={error_capacidade_campo_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="capacidade_campo_camp_7"
            value={tabela?.capacidade_campo_camp_7 === undefined || tabela?.capacidade_campo_camp_7 === null ? "" : tabela.capacidade_campo_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_capacidade_campo_camp_7}
            helperText={error_capacidade_campo_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft> TEOR CRÍTICO CULTURAL (mm) </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_crit_cul_camp_1"
            value={tabela?.teor_crit_cul_camp_1 === undefined || tabela?.teor_crit_cul_camp_1 === null ? "" : tabela.teor_crit_cul_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_crit_cul_camp_1}
            helperText={error_teor_crit_cul_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_crit_cul_camp_2"
            value={tabela?.teor_crit_cul_camp_2 === undefined || tabela?.teor_crit_cul_camp_2 === null ? "" : tabela.teor_crit_cul_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_crit_cul_camp_2}
            helperText={error_teor_crit_cul_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_crit_cul_camp_3"
            value={tabela?.teor_crit_cul_camp_3 === undefined || tabela?.teor_crit_cul_camp_3 === null ? "" : tabela.teor_crit_cul_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_crit_cul_camp_3}
            helperText={error_teor_crit_cul_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_crit_cul_camp_4"
            value={tabela?.teor_crit_cul_camp_4 === undefined || tabela?.teor_crit_cul_camp_4 === null ? "" : tabela.teor_crit_cul_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_crit_cul_camp_4}
            helperText={error_teor_crit_cul_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_crit_cul_camp_5"
            value={tabela?.teor_crit_cul_camp_5 === undefined || tabela?.teor_crit_cul_camp_5 === null ? "" : tabela.teor_crit_cul_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_crit_cul_camp_5}
            helperText={error_teor_crit_cul_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_crit_cul_camp_6"
            value={tabela?.teor_crit_cul_camp_6 === undefined || tabela?.teor_crit_cul_camp_6 === null ? "" : tabela.teor_crit_cul_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_crit_cul_camp_6}
            helperText={error_teor_crit_cul_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_crit_cul_camp_7"
            value={tabela?.teor_crit_cul_camp_7 === undefined || tabela?.teor_crit_cul_camp_7 === null ? "" : tabela.teor_crit_cul_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_crit_cul_camp_7}
            helperText={error_teor_crit_cul_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>TEOR DE ÁGUA DO SOLO - INÍCIO (mm)  </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_inicio_camp_1"
            value={tabela?.teor_agua_inicio_camp_1 === undefined || tabela?.teor_agua_inicio_camp_1 === null ? "" : tabela.teor_agua_inicio_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_inicio_camp_1}
            helperText={error_teor_agua_inicio_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_inicio_camp_2"
            value={tabela?.teor_agua_inicio_camp_2 === undefined || tabela?.teor_agua_inicio_camp_2 === null ? "" : tabela.teor_agua_inicio_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_inicio_camp_2}
            helperText={error_teor_agua_inicio_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_inicio_camp_3"
            value={tabela?.teor_agua_inicio_camp_3 === undefined || tabela?.teor_agua_inicio_camp_3 === null ? "" : tabela.teor_agua_inicio_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_inicio_camp_3}
            helperText={error_teor_agua_inicio_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_inicio_camp_4"
            value={tabela?.teor_agua_inicio_camp_4 === undefined || tabela?.teor_agua_inicio_camp_4 === null ? "" : tabela.teor_agua_inicio_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_inicio_camp_4}
            helperText={error_teor_agua_inicio_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_inicio_camp_5"
            value={tabela?.teor_agua_inicio_camp_5 === undefined || tabela?.teor_agua_inicio_camp_5 === null ? "" : tabela.teor_agua_inicio_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_inicio_camp_5}
            helperText={error_teor_agua_inicio_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_inicio_camp_6"
            value={tabela?.teor_agua_inicio_camp_6 === undefined || tabela?.teor_agua_inicio_camp_6 === null ? "" : tabela.teor_agua_inicio_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_inicio_camp_6}
            helperText={error_teor_agua_inicio_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_inicio_camp_7"
            value={tabela?.teor_agua_inicio_camp_7 === undefined || tabela?.teor_agua_inicio_camp_7 === null ? "" : tabela.teor_agua_inicio_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_inicio_camp_7}
            helperText={error_teor_agua_inicio_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>ET0 (mm)</StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="eto_camp_1"
            value={tabela?.eto_camp_1 === undefined || tabela?.eto_camp_1 === null ? "" : tabela.eto_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_eto_camp_1}
            helperText={error_eto_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="eto_camp_2"
            value={tabela?.eto_camp_2 === undefined || tabela?.eto_camp_2 === null ? "" : tabela.eto_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_eto_camp_2}
            helperText={error_eto_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="eto_camp_3"
            value={tabela?.eto_camp_3 === undefined || tabela?.eto_camp_3 === null ? "" : tabela.eto_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_eto_camp_3}
            helperText={error_eto_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="eto_camp_4"
            value={tabela?.eto_camp_4 === undefined || tabela?.eto_camp_4 === null ? "" : tabela.eto_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_eto_camp_4}
            helperText={error_eto_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="eto_camp_5"
            value={tabela?.eto_camp_5 === undefined || tabela?.eto_camp_5 === null ? "" : tabela.eto_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_eto_camp_5}
            helperText={error_eto_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="eto_camp_6"
            value={tabela?.eto_camp_6 === undefined || tabela?.eto_camp_6 === null ? "" : tabela.eto_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_eto_camp_6}
            helperText={error_eto_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="eto_camp_7"
            value={tabela?.eto_camp_7 === undefined || tabela?.eto_camp_7 === null ? "" : tabela.eto_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_eto_camp_7}
            helperText={error_eto_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>KC</StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="kc_camp_1"
            value={tabela?.kc_camp_1 === undefined || tabela?.kc_camp_1 === null ? "" : tabela.kc_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_kc_camp_1}
            helperText={error_kc_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="kc_camp_2"
            value={tabela?.kc_camp_2 === undefined || tabela?.kc_camp_2 === null ? "" : tabela.kc_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_kc_camp_2}
            helperText={error_kc_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="kc_camp_3"
            value={tabela?.kc_camp_3 === undefined || tabela?.kc_camp_3 === null ? "" : tabela.kc_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_kc_camp_3}
            helperText={error_kc_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="kc_camp_4"
            value={tabela?.kc_camp_4 === undefined || tabela?.kc_camp_4 === null ? "" : tabela.kc_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_kc_camp_4}
            helperText={error_kc_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="kc_camp_5"
            value={tabela?.kc_camp_5 === undefined || tabela?.kc_camp_5 === null ? "" : tabela.kc_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_kc_camp_5}
            helperText={error_kc_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="kc_camp_6"
            value={tabela?.kc_camp_6 === undefined || tabela?.kc_camp_6 === null ? "" : tabela.kc_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_kc_camp_6}
            helperText={error_kc_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="kc_camp_7"
            value={tabela?.kc_camp_7 === undefined || tabela?.kc_camp_7 === null ? "" : tabela.kc_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_kc_camp_7}
            helperText={error_kc_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>ETC (mm)</StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="etc_camp_1"
            value={tabela?.etc_camp_1 === undefined || tabela?.etc_camp_1 === null ? "" : tabela.etc_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_etc_camp_1}
            helperText={error_etc_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="etc_camp_2"
            value={tabela?.etc_camp_2 === undefined || tabela?.etc_camp_2 === null ? "" : tabela.etc_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_etc_camp_2}
            helperText={error_etc_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="etc_camp_3"
            value={tabela?.etc_camp_3 === undefined || tabela?.etc_camp_3 === null ? "" : tabela.etc_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_etc_camp_3}
            helperText={error_etc_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="etc_camp_4"
            value={tabela?.etc_camp_4 === undefined || tabela?.etc_camp_4 === null ? "" : tabela.etc_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_etc_camp_4}
            helperText={error_etc_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="etc_camp_5"
            value={tabela?.etc_camp_5 === undefined || tabela?.etc_camp_5 === null ? "" : tabela.etc_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_etc_camp_5}
            helperText={error_etc_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="etc_camp_6"
            value={tabela?.etc_camp_6 === undefined || tabela?.etc_camp_6 === null ? "" : tabela.etc_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_etc_camp_6}
            helperText={error_etc_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="etc_camp_7"
            value={tabela?.etc_camp_7 === undefined || tabela?.etc_camp_7 === null ? "" : tabela.etc_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_etc_camp_7}
            helperText={error_etc_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft> PRECIPITAÇÃO TOTAL (mm) </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="precipita_t_camp_1"
            value={tabela?.precipita_t_camp_1 === undefined || tabela?.precipita_t_camp_1 === null ? "" : tabela.precipita_t_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_precipita_t_camp_1}
            helperText={error_precipita_t_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="precipita_t_camp_2"
            value={tabela?.precipita_t_camp_2 === undefined || tabela?.precipita_t_camp_2 === null ? "" : tabela.precipita_t_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_precipita_t_camp_2}
            helperText={error_precipita_t_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="precipita_t_camp_3"
            value={tabela?.precipita_t_camp_3 === undefined || tabela?.precipita_t_camp_3 === null ? "" : tabela.precipita_t_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_precipita_t_camp_3}
            helperText={error_precipita_t_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="precipita_t_camp_4"
            value={tabela?.precipita_t_camp_4 === undefined || tabela?.precipita_t_camp_4 === null ? "" : tabela.precipita_t_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_precipita_t_camp_4}
            helperText={error_precipita_t_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="precipita_t_camp_5"
            value={tabela?.precipita_t_camp_5 === undefined || tabela?.precipita_t_camp_5 === null ? "" : tabela.precipita_t_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_precipita_t_camp_5}
            helperText={error_precipita_t_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="precipita_t_camp_6"
            value={tabela?.precipita_t_camp_6 === undefined || tabela?.precipita_t_camp_6 === null ? "" : tabela.precipita_t_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_precipita_t_camp_6}
            helperText={error_precipita_t_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="precipita_t_camp_7"
            value={tabela?.precipita_t_camp_7 === undefined || tabela?.precipita_t_camp_7 === null ? "" : tabela.precipita_t_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_precipita_t_camp_7}
            helperText={error_precipita_t_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft> VARIAÇÃO DA ÁGUA NO SOLO (mm)</StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="variacao_agu_camp_1"
            value={tabela?.variacao_agu_camp_1 === undefined || tabela?.variacao_agu_camp_1 === null ? "" : tabela.variacao_agu_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_variacao_agu_camp_1}
            helperText={error_variacao_agu_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="variacao_agu_camp_2"
            value={tabela?.variacao_agu_camp_2 === undefined || tabela?.variacao_agu_camp_2 === null ? "" : tabela.variacao_agu_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_variacao_agu_camp_2}
            helperText={error_variacao_agu_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="variacao_agu_camp_3"
            value={tabela?.variacao_agu_camp_3 === undefined || tabela?.variacao_agu_camp_3 === null ? "" : tabela.variacao_agu_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_variacao_agu_camp_3}
            helperText={error_variacao_agu_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="variacao_agu_camp_4"
            value={tabela?.variacao_agu_camp_4 === undefined || tabela?.variacao_agu_camp_4 === null ? "" : tabela.variacao_agu_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_variacao_agu_camp_4}
            helperText={error_variacao_agu_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="variacao_agu_camp_5"
            value={tabela?.variacao_agu_camp_5 === undefined || tabela?.variacao_agu_camp_5 === null ? "" : tabela.variacao_agu_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_variacao_agu_camp_5}
            helperText={error_variacao_agu_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="variacao_agu_camp_6"
            value={tabela?.variacao_agu_camp_6 === undefined || tabela?.variacao_agu_camp_6 === null ? "" : tabela.variacao_agu_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_variacao_agu_camp_6}
            helperText={error_variacao_agu_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="variacao_agu_camp_7"
            value={tabela?.variacao_agu_camp_7 === undefined || tabela?.variacao_agu_camp_7 === null ? "" : tabela.variacao_agu_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_variacao_agu_camp_7}
            helperText={error_variacao_agu_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft> TEOR DE ÁGUA DO SOLO - SEM REGA (mm) </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_solo_s_rega_camp_1"
            value={tabela?.teor_agua_solo_s_rega_camp_1 === undefined || tabela?.teor_agua_solo_s_rega_camp_1 === null ? "" : tabela.teor_agua_solo_s_rega_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_solo_s_rega_camp_1}
            helperText={error_teor_agua_solo_s_rega_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_solo_s_rega_camp_2"
            value={tabela?.teor_agua_solo_s_rega_camp_2 === undefined || tabela?.teor_agua_solo_s_rega_camp_2 === null ? "" : tabela.teor_agua_solo_s_rega_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_solo_s_rega_camp_2}
            helperText={error_teor_agua_solo_s_rega_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_solo_s_rega_camp_3"
            value={tabela?.teor_agua_solo_s_rega_camp_3 === undefined || tabela?.teor_agua_solo_s_rega_camp_3 === null ? "" : tabela.teor_agua_solo_s_rega_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_solo_s_rega_camp_3}
            helperText={error_teor_agua_solo_s_rega_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_solo_s_rega_camp_4"
            value={tabela?.teor_agua_solo_s_rega_camp_4 === undefined || tabela?.teor_agua_solo_s_rega_camp_4 === null ? "" : tabela.teor_agua_solo_s_rega_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_solo_s_rega_camp_4}
            helperText={error_teor_agua_solo_s_rega_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_solo_s_rega_camp_5"
            value={tabela?.teor_agua_solo_s_rega_camp_5 === undefined || tabela?.teor_agua_solo_s_rega_camp_5 === null ? "" : tabela.teor_agua_solo_s_rega_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_solo_s_rega_camp_5}
            helperText={error_teor_agua_solo_s_rega_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_solo_s_rega_camp_6"
            value={tabela?.teor_agua_solo_s_rega_camp_6 === undefined || tabela?.teor_agua_solo_s_rega_camp_6 === null ? "" : tabela.teor_agua_solo_s_rega_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_solo_s_rega_camp_6}
            helperText={error_teor_agua_solo_s_rega_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_solo_s_rega_camp_7"
            value={tabela?.teor_agua_solo_s_rega_camp_7 === undefined || tabela?.teor_agua_solo_s_rega_camp_7 === null ? "" : tabela.teor_agua_solo_s_rega_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_solo_s_rega_camp_7}
            helperText={error_teor_agua_solo_s_rega_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft> LEITURA DA SONDA (% OU kPa) </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="leitura_sonda_1_camp_1"
            value={tabela?.leitura_sonda_1_camp_1 === undefined || tabela?.leitura_sonda_1_camp_1 === null ? "" : tabela.leitura_sonda_1_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_leitura_sonda_1_camp_1}
            helperText={error_leitura_sonda_1_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="leitura_sonda_1_camp_2"
            value={tabela?.leitura_sonda_1_camp_2 === undefined || tabela?.leitura_sonda_1_camp_2 === null ? "" : tabela.leitura_sonda_1_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_leitura_sonda_1_camp_2}
            helperText={error_leitura_sonda_1_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="leitura_sonda_1_camp_3"
            value={tabela?.leitura_sonda_1_camp_3 === undefined || tabela?.leitura_sonda_1_camp_3 === null ? "" : tabela.leitura_sonda_1_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_leitura_sonda_1_camp_3}
            helperText={error_leitura_sonda_1_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="leitura_sonda_1_camp_4"
            value={tabela?.leitura_sonda_1_camp_4 === undefined || tabela?.leitura_sonda_1_camp_4 === null ? "" : tabela.leitura_sonda_1_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_leitura_sonda_1_camp_4}
            helperText={error_leitura_sonda_1_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="leitura_sonda_1_camp_5"
            value={tabela?.leitura_sonda_1_camp_5 === undefined || tabela?.leitura_sonda_1_camp_5 === null ? "" : tabela.leitura_sonda_1_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_leitura_sonda_1_camp_5}
            helperText={error_leitura_sonda_1_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="leitura_sonda_1_camp_6"
            value={tabela?.leitura_sonda_1_camp_6 === undefined || tabela?.leitura_sonda_1_camp_6 === null ? "" : tabela.leitura_sonda_1_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_leitura_sonda_1_camp_6}
            helperText={error_leitura_sonda_1_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="leitura_sonda_1_camp_7"
            value={tabela?.leitura_sonda_1_camp_7 === undefined || tabela?.leitura_sonda_1_camp_7 === null ? "" : tabela.leitura_sonda_1_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_leitura_sonda_1_camp_7}
            helperText={error_leitura_sonda_1_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft> LEITURA DA SONDA (mm) </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="leitura_sonda_2_camp_1"
            value={tabela?.leitura_sonda_2_camp_1 === undefined || tabela?.leitura_sonda_2_camp_1 === null ? "" : tabela.leitura_sonda_2_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_leitura_sonda_2_camp_1}
            helperText={error_leitura_sonda_2_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="leitura_sonda_2_camp_2"
            value={tabela?.leitura_sonda_2_camp_2 === undefined || tabela?.leitura_sonda_2_camp_2 === null ? "" : tabela.leitura_sonda_2_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_leitura_sonda_2_camp_2}
            helperText={error_leitura_sonda_2_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="leitura_sonda_2_camp_3"
            value={tabela?.leitura_sonda_2_camp_3 === undefined || tabela?.leitura_sonda_2_camp_3 === null ? "" : tabela.leitura_sonda_2_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_leitura_sonda_2_camp_3}
            helperText={error_leitura_sonda_2_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="leitura_sonda_2_camp_4"
            value={tabela?.leitura_sonda_2_camp_4 === undefined || tabela?.leitura_sonda_2_camp_4 === null ? "" : tabela.leitura_sonda_2_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_leitura_sonda_2_camp_4}
            helperText={error_leitura_sonda_2_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="leitura_sonda_2_camp_5"
            value={tabela?.leitura_sonda_2_camp_5 === undefined || tabela?.leitura_sonda_2_camp_5 === null ? "" : tabela.leitura_sonda_2_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_leitura_sonda_2_camp_5}
            helperText={error_leitura_sonda_2_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="leitura_sonda_2_camp_6"
            value={tabela?.leitura_sonda_2_camp_6 === undefined || tabela?.leitura_sonda_2_camp_6 === null ? "" : tabela.leitura_sonda_2_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_leitura_sonda_2_camp_6}
            helperText={error_leitura_sonda_2_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="leitura_sonda_2_camp_7"
            value={tabela?.leitura_sonda_2_camp_7 === undefined || tabela?.leitura_sonda_2_camp_7 === null ? "" : tabela.leitura_sonda_2_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_leitura_sonda_2_camp_7}
            helperText={error_leitura_sonda_2_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft> FOLGA PARA PRÓXIMA REGA (mm) </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="folga_prox_rega_camp_1"
            value={tabela?.folga_prox_rega_camp_1 === undefined || tabela?.folga_prox_rega_camp_1 === null ? "" : tabela.folga_prox_rega_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_folga_prox_rega_camp_1}
            helperText={error_folga_prox_rega_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="folga_prox_rega_camp_2"
            value={tabela?.folga_prox_rega_camp_2 === undefined || tabela?.folga_prox_rega_camp_2 === null ? "" : tabela.folga_prox_rega_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_folga_prox_rega_camp_2}
            helperText={error_folga_prox_rega_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="folga_prox_rega_camp_3"
            value={tabela?.folga_prox_rega_camp_3 === undefined || tabela?.folga_prox_rega_camp_3 === null ? "" : tabela.folga_prox_rega_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_folga_prox_rega_camp_3}
            helperText={error_folga_prox_rega_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="folga_prox_rega_camp_4"
            value={tabela?.folga_prox_rega_camp_4 === undefined || tabela?.folga_prox_rega_camp_4 === null ? "" : tabela.folga_prox_rega_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_folga_prox_rega_camp_4}
            helperText={error_folga_prox_rega_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="folga_prox_rega_camp_5"
            value={tabela?.folga_prox_rega_camp_5 === undefined || tabela?.folga_prox_rega_camp_5 === null ? "" : tabela.folga_prox_rega_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_folga_prox_rega_camp_5}
            helperText={error_folga_prox_rega_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="folga_prox_rega_camp_6"
            value={tabela?.folga_prox_rega_camp_6 === undefined || tabela?.folga_prox_rega_camp_6 === null ? "" : tabela.folga_prox_rega_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_folga_prox_rega_camp_6}
            helperText={error_folga_prox_rega_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="folga_prox_rega_camp_7"
            value={tabela?.folga_prox_rega_camp_7 === undefined || tabela?.folga_prox_rega_camp_7 === null ? "" : tabela.folga_prox_rega_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_folga_prox_rega_camp_7}
            helperText={error_folga_prox_rega_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft> REGA - LEITURA DO CONTADOR NO FINAL (m3) </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_leitura_camp_1"
            value={tabela?.rega_leitura_camp_1 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_leitura_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_leitura_camp_1}
            helperText={error_rega_leitura_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_leitura_camp_2"
            value={tabela?.rega_leitura_camp_2 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_leitura_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_leitura_camp_2}
            helperText={error_rega_leitura_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_leitura_camp_3"
            value={tabela?.rega_leitura_camp_3 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_leitura_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_leitura_camp_3}
            helperText={error_rega_leitura_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_leitura_camp_4"
            value={tabela?.rega_leitura_camp_4 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_leitura_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_leitura_camp_4}
            helperText={error_rega_leitura_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_leitura_camp_5"
            value={tabela?.rega_leitura_camp_5 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_leitura_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_leitura_camp_5}
            helperText={error_rega_leitura_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_leitura_camp_6"
            value={tabela?.rega_leitura_camp_6 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_leitura_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_leitura_camp_6}
            helperText={error_rega_leitura_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_leitura_camp_7"
            value={tabela?.rega_leitura_camp_7 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_leitura_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_leitura_camp_7}
            helperText={error_rega_leitura_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>
          REGA - DOSE TOTAL APLICADA (mm)
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_dose_total_camp_1"
            value={tabela?.rega_dose_total_camp_1 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_dose_total_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_dose_total_camp_1}
            helperText={error_rega_dose_total_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_dose_total_camp_2"
            value={tabela?.rega_dose_total_camp_2 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_dose_total_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_dose_total_camp_2}
            helperText={error_rega_dose_total_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_dose_total_camp_3"
            value={tabela?.rega_dose_total_camp_3 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_dose_total_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_dose_total_camp_3}
            helperText={error_rega_dose_total_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_dose_total_camp_4"
            value={tabela?.rega_dose_total_camp_4 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_dose_total_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_dose_total_camp_4}
            helperText={error_rega_dose_total_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_dose_total_camp_5"
            value={tabela?.rega_dose_total_camp_5 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_dose_total_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_dose_total_camp_5}
            helperText={error_rega_dose_total_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_dose_total_camp_6"
            value={tabela?.rega_dose_total_camp_6 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_dose_total_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_dose_total_camp_6}
            helperText={error_rega_dose_total_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_dose_total_camp_7"
            value={tabela?.rega_dose_total_camp_7 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_dose_total_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_dose_total_camp_7}
            helperText={error_rega_dose_total_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>
          REGA - DOSE ÚTIL (mm) – APÓS REGA
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_dose_util_camp_1"
            value={tabela?.rega_dose_util_camp_1 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_dose_util_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_dose_util_camp_1}
            helperText={error_rega_dose_util_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_dose_util_camp_2"
            value={tabela?.rega_dose_util_camp_2 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_dose_util_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_dose_util_camp_2}
            helperText={error_rega_dose_util_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_dose_util_camp_3"
            value={tabela?.rega_dose_util_camp_3 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_dose_util_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_dose_util_camp_3}
            helperText={error_rega_dose_util_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_dose_util_camp_4"
            value={tabela?.rega_dose_util_camp_4 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_dose_util_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_dose_util_camp_4}
            helperText={error_rega_dose_util_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_dose_util_camp_5"
            value={tabela?.rega_dose_util_camp_5 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_dose_util_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_dose_util_camp_5}
            helperText={error_rega_dose_util_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_dose_util_camp_6"
            value={tabela?.rega_dose_util_camp_6 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_dose_util_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_dose_util_camp_6}
            helperText={error_rega_dose_util_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="rega_dose_util_camp_7"
            value={tabela?.rega_dose_util_camp_7 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.rega_dose_util_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_rega_dose_util_camp_7}
            helperText={error_rega_dose_util_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>
          TEOR DE ÁGUA DO SOLO (mm)
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_solo_1_camp_1"
            value={tabela?.teor_agua_solo_1_camp_1 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.teor_agua_solo_1_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_solo_1_camp_1}
            helperText={error_teor_agua_solo_1_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_solo_1_camp_2"
            value={tabela?.teor_agua_solo_1_camp_2 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.teor_agua_solo_1_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_solo_1_camp_2}
            helperText={error_teor_agua_solo_1_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_solo_1_camp_3"
            value={tabela?.teor_agua_solo_1_camp_3 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.teor_agua_solo_1_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_solo_1_camp_3}
            helperText={error_teor_agua_solo_1_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_solo_1_camp_4"
            value={tabela?.teor_agua_solo_1_camp_4 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.teor_agua_solo_1_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_solo_1_camp_4}
            helperText={error_teor_agua_solo_1_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_solo_1_camp_5"
            value={tabela?.teor_agua_solo_1_camp_5 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.teor_agua_solo_1_camp_5.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_solo_1_camp_5}
            helperText={error_teor_agua_solo_1_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_solo_1_camp_6"
            value={tabela?.teor_agua_solo_1_camp_6 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.teor_agua_solo_1_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_solo_1_camp_6}
            helperText={error_teor_agua_solo_1_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="teor_agua_solo_1_camp_7"
            value={tabela?.teor_agua_solo_1_camp_7 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.teor_agua_solo_1_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_teor_agua_solo_1_camp_7}
            helperText={error_teor_agua_solo_1_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>
          PERDA DE ÁGUA (CHUVA OU REGA EXCESSIVA)
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="perda_agua_camp_1"
            value={tabela?.perda_agua_camp_1 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.perda_agua_camp_1.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_perda_agua_camp_1}
            helperText={error_perda_agua_camp_1 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="perda_agua_camp_2"
            value={tabela?.perda_agua_camp_2 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.perda_agua_camp_2.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_perda_agua_camp_2}
            helperText={error_perda_agua_camp_2 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="perda_agua_camp_3"
            value={tabela?.perda_agua_camp_3 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.perda_agua_camp_3.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_perda_agua_camp_3}
            helperText={error_perda_agua_camp_3 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="perda_agua_camp_4"
            value={tabela?.perda_agua_camp_4 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.perda_agua_camp_4.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_perda_agua_camp_4}
            helperText={error_perda_agua_camp_4 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="perda_agua_camp_5"
            onChange={onInputChange}
            value={tabela?.perda_agua_camp_5 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.perda_agua_camp_5.toString().replace('.', ',')}
            error={error_perda_agua_camp_5}
            helperText={error_perda_agua_camp_5 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="perda_agua_camp_6"
            value={tabela?.perda_agua_camp_6 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.perda_agua_camp_6.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_perda_agua_camp_6}
            helperText={error_perda_agua_camp_6 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
        <StyledTableHeadLeft>
          <CustomTextField
            name="perda_agua_camp_7"
            value={tabela?.perda_agua_camp_7 === undefined || tabela?.prefundidad_radi_camp_1 === null ? "" : tabela.perda_agua_camp_7.toString().replace('.', ',')}
            onChange={onInputChange}
            error={error_perda_agua_camp_7}
            helperText={error_perda_agua_camp_7 ? message_apenas_numero : ""}
          />
        </StyledTableHeadLeft>
      </TableRow>
      <TableRow>
        <TableCell
          colSpan={4}
          sx={{
            fontWeight: 600,
            paddingTop: 10,
            fontFamily: "candara",
            fontSize: 14,
          }}
        >
          PREENCHER APENAS OS CAMPOS QUE SE APLICAM
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={4}
          sx={{ fontFamily: "candara", fontSize: 14 }}
        >
          IDENTIFICAÇÃO DO AVISO DE REGA com sonda (Data):
          <BasicPopover text={"A ser preenchido apenas por regantes da classe A."} />
          <TextField
            variant="filled"
            type="date"
            name="ident_camp1"
            value={tabela?.ident_camp1 === null ? "" : tabela?.ident_camp1}
            onChange={onInputChange}
          />
        </TableCell>


      </TableRow>
      <TableRow>
        <TableCell colSpan={4}

          sx={{ fontFamily: "candara", fontSize: 14, flexDirection: 'column' }}
        >
          <Stack
            direction="row"
            sx={{ justifyContent: "center", alignItems: "center" }}
          >
            IDENTIFICAÇÃO DO AVISO DE REGA com sonda (dotação
            recomendada m3/ha):
            <BasicPopover text={"A ser preenchido apenas por regantes da classe A."} />
            <CustomTextField

              name="ident_camp2"
              value={tabela?.ident_camp2 === undefined ? "" : tabela.ident_camp2}
              onChange={onInputChange}
              error={error_ident_camp2}
              helperText={error_ident_camp2 ? message_apenas_numero : ""}
            />
          </Stack>
        </TableCell>


      </TableRow>
      <TableRow>
        <TableCell colSpan={4}
          sx={{ fontFamily: "candara", fontSize: 14 }}
        >
          IDENTIFICAÇÃO DO AVISO DE REGA com imagem satélite
          IVDI (Data):
          <BasicPopover text={"A ser preenchido apenas por regantes da classe A."} />
          <TextField
            variant="filled"
            type="date"
            name="ident_camp3"
            value={tabela?.ident_camp3 === null ? "" : tabela?.ident_camp3}
            onChange={onInputChange}
          />
        </TableCell>

      </TableRow>
      <TableRow>
        <TableCell colSpan={4}

          sx={{ fontFamily: "candara", fontSize: 14 }}
        >
          <Stack
            direction="row"
            sx={{ justifyContent: "center", alignItems: "center" }}
          >
            IDENTIFICAÇÃO DO AVISO DE REGA com imagem satélite
            IVDI (dotação recomendada m3/ha):
            <BasicPopover text={"A ser preenchido apenas por regantes da classe A."} />
            <CustomTextField
              name="ident_camp4"
              value={tabela?.ident_camp4 === undefined ? "" : tabela.ident_camp4}
              onChange={onInputChange}
              error={error_ident_camp4}
              helperText={error_ident_camp4 ? message_apenas_numero : ""}
            />
          </Stack>
        </TableCell>

      </TableRow>
    </>
  );
};
